import _ from 'lodash'
import Backbone from 'backbone'
import NumericFilter from 'scoreboard/reports/common/filter/numeric-filter'
import PeriodRangeDateFilter from './period-range-date-filter'
import template from './numeric-applies-to-period-filter.hbs'

const NumericAppliesToPeriodFilter = Backbone.View.extend({

	className: 'report-filters filter numeric-applies-to-date-filter',

	/**
	 * @constructs A view that combines a number and date filter together to
	 * provide a scorecards filter where you can specify a number in a given date range
	 *
	 * @param options
	 */
	initialize: function(options = {}) {
		this.options = options
		this.data = options.data
		const numericFilterOptions = _.extend(_.cloneDeep(options), {
			isScorecardScore: options.filterKey === 'score'
		})
		this.numericFilter = new NumericFilter(numericFilterOptions)
		let dateFilterOptions = _.extend({
			operatorLabel: 'common.appliesTo'
		}, _.cloneDeep(options))
		this.periodRangeDateFilter = new PeriodRangeDateFilter(dateFilterOptions)
	},

	render: function() {
		this.$el.html(template())
		this.numericFilter.setElement(this.$('.numeric-filter-container')).render()
		this.periodRangeDateFilter.setElement(this.$('.applies-to-container')).render()
		return this
	},

	/**
	 * Provides validation to this view
	 */
	test: function() {
		let numericTest = this.numericFilter.test()
		let dateTest = this.periodRangeDateFilter.test()
		if (_.isNil(numericTest) && _.isNil(dateTest)) {
			return null
		}
		return _.filter([numericTest, dateTest], v => !_.isNil(v))
	},

	/**
	 * Returns the data gather by the filters used in this view
	 */
	gather: function(e) {
		return _.extend(this.data, this.numericFilter.gather(), this.periodRangeDateFilter.gather())
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.numericFilter, this.periodRangeDateFilter], 'remove')
	}

})

export default NumericAppliesToPeriodFilter

NumericAppliesToPeriodFilter.__filename__ = 'reports/wizard/filter-meta/numeric-applies-to-period-filter.js'
